module.exports = __webpack_public_path__ + "img/tigong4.800334a8.png";